import {
  ChangeDetectorRef,
  Component,
  Injector,
} from '@angular/core';

import { ApFindControlModalService } from './ap-findcontrol-modal.service';
import { ApFindControlService } from './ap-findcontrol.service';
import { ApFindControlBaseComponent } from './ap-findcontrol.base.component';
import { ValidationErrors } from '@angular/forms';
import { SystemGuid } from 'webcommon/shared';
import { FindControlIdService } from 'webcommon/legacy-common';

// TODO: convert to use stuff in base-control folder
@Component({
  selector: 'ap-findcontrol',
  templateUrl: './ap-findcontrol.component.html',
})
export class ApFindControlComponent extends ApFindControlBaseComponent<string[]>  {

  constructor(
    apFindControlModalService: ApFindControlModalService,
    apFindControlService: ApFindControlService,
    findControlIdService: FindControlIdService,
    changeDetector: ChangeDetectorRef,
    elementInjector: Injector,
    systemGuid: SystemGuid,
  ) {
    super(apFindControlModalService, apFindControlService, findControlIdService, changeDetector, elementInjector, systemGuid);
  }

  protected createFormControlValueOrDefault(): string[] {
    return this.selectedPks;
  }

  protected matchesCurrentFormControlValue(data: string[]): boolean {
    return JSON.stringify(this.findControlFormControl?.value) === JSON.stringify(data);
  }

  protected convertFormValueToSelectedPks(value: string[] | string | null | undefined): string[] {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string' && value.length > 0) return [value];
    return [];
  }

  validate = (): ValidationErrors | null => {
    if (!this.chips.length) {
      if (this.isShowRequiredOnly()) { return null; }
    }
    const valid = this.getIsValid();
    return valid
      ? null
      : {
        required: true,
      };
  };

  protected getIsValid(): boolean {
    const isValid = !this.required || !!(this.chips.length);
    return isValid;
  }
}
